import React from "react";
import { Table, ConfigProvider } from "antd";


interface TableRow {
  key: React.Key;
  details?: string[];
  [key: string]: any; // Allow additional fields
}

interface CustomTableProps<T extends TableRow> {
  initialDataSource: T[];
  columns: any;
  scrollEnabled?: boolean;
  scrollX?: number | string;
  scrollY?: number | string;
  scroll?: any;
  filterData?: boolean;
  pagination?: any;
  rowKey?: any;
  style?: React.CSSProperties;
  className?: string;
  rowClassName?: string | ((record: T, index: number) => string);
  summary?: any;
}

export const CustomTable = <T extends TableRow>({
  initialDataSource,
  columns,
  pagination,
  rowKey= 'key',
   scroll = {x: "max-content", y: 70 * 10 },
  style,
  className='custom-table',
  rowClassName='rowClassName',
  summary,
  ...props
}: CustomTableProps<T>) => {

  

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            rowHoverBg: '#e6f4ff',

          },
        },
      }}
    >
    <Table
      columns={columns}
      dataSource={initialDataSource} // Directly use initialDataSource
      rowKey={rowKey}
      pagination={pagination}
      scroll={scroll}
      className={className}
      rowClassName={rowClassName}
      summary={summary}
      
      
      style={{
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 -4px 6px rgba(0, 0, 0, 0.1)",
        margin:1,
        borderRadius: 4,
      }}
      {...props}
    />
    </ConfigProvider>
  );
};
